import { useEffect } from 'react';
import { ReactRenderTracker } from './ReactRenderTracker';

/**
 * useRenderCount — register a render with ReactRenderTracker.
 *
 * Two-line addition at the top of any component you want to profile.
 *   useRenderCount('BuffBar');
 *
 * Zero overhead when tracker is disabled (the singleton early-returns
 * inside `record()`). Enable via `?reactprofile=1` URL flag or DevTools
 * `__REACT_RENDER_TRACKER__.setEnabled(true)`.
 *
 * useEffect with no deps runs after every render — this counts ALL
 * renders (mount, prop change, parent re-render), which is what we
 * want for memo-candidate detection.
 */
export function useRenderCount(id: string): void {
  useEffect(() => {
    ReactRenderTracker.record(id);
  });
}
